export const ELEMENTS = [
  // Input Controls
  {
    type: 'short-answer',
    label: 'Short Answer',
    slug: 'short_answer',
    category: 'text',
    available_for: ['page'],
  },
  {
    type: 'long-answer',
    label: 'Long Answer',
    slug: 'long_answer',
    category: 'text',
    available_for: ['page'],
  },

  // Numbers
  { type: 'number', label: 'Number', slug: 'number', category: 'numbers', available_for: ['page'] },
  { type: 'slider', label: 'Slider', slug: 'slider', category: 'numbers', available_for: ['page'] },
  {
    type: 'currency',
    label: 'Currency',
    slug: 'currency',
    category: 'numbers',
    comingSoon: true,
    available_for: ['page'],
  },
  {
    type: 'star-rating',
    label: 'Star Rating',
    slug: 'star_rating',
    category: 'numbers',
    available_for: ['page'],
  },

  // Choices
  {
    type: 'single-choice',
    label: 'Single Choice',
    slug: 'single_choice',
    category: 'choices',
    available_for: ['page'],
  },
  {
    type: 'multiple-choice',
    label: 'Multiple Choice',
    slug: 'multiple_choice',
    category: 'choices',
    available_for: ['page'],
  },
  {
    type: 'picture-choice',
    label: 'Picture Choice',
    slug: 'picture_choice',
    category: 'choices',
    available_for: ['page'],
  },
  {
    type: 'dropdown',
    label: 'Dropdown',
    slug: 'dropdown',
    category: 'choices',
    comingSoon: true,
    available_for: ['page'],
  },

  // Product Selection (CPQ)
  {
    type: 'product-selection',
    label: 'Product Selection',
    slug: 'product_selection',
    category: 'cpq',
    available_for: ['page'],
    configuratorOnly: true, // Alleen beschikbaar in configurators
  },
  {
    type: 'configurator-choice',
    label: 'Configurator Choice',
    slug: 'configurator_choice',
    category: 'cpq',
    available_for: ['page'],
    configuratorOnly: true, // Alleen beschikbaar in configurators
  },
  {
    type: 'cpq-quote-summary',
    label: 'Quote Summary',
    slug: 'cpq_quote_summary',
    category: 'cpq',
    available_for: ['page'],
    configuratorOnly: true,
  },

  // Selection
  { type: 'switch', label: 'Switch', slug: 'switch', category: 'options', available_for: ['page'] },
  {
    type: 'checkbox',
    label: 'Checkbox',
    slug: 'checkbox',
    category: 'options',
    comingSoon: true,
    available_for: ['page'],
  },

  // Date & Time
  {
    type: 'date',
    label: 'Date',
    slug: 'date',
    category: 'date',
    available_for: ['page'],
  },
  {
    type: 'time',
    label: 'Time',
    slug: 'time',
    category: 'date',
    comingSoon: true,
    available_for: ['page'],
  },

  // Special Inputs
  {
    type: 'formula',
    label: 'Formula',
    slug: 'formula',
    category: 'special',
    available_for: ['page', 'ending'],
  },
  {
    type: 'color-picker',
    label: 'Color Picker',
    slug: 'color_picker',
    category: 'special',
    comingSoon: true,
    available_for: ['page'],
  },
  {
    type: 'file-upload',
    label: 'File Upload',
    slug: 'file_upload',
    category: 'special',
    available_for: ['page'],
  },
  {
    type: 'photo-drawing',
    label: 'Photo with Drawing',
    slug: 'photo_drawing',
    category: 'special',
    available_for: ['page'],
  },
  {
    type: 'scheduling',
    label: 'Scheduling',
    slug: 'scheduling',
    category: 'special',
    available_for: ['page'],
  },
  {
    type: 'payment',
    label: 'Payment',
    slug: 'payment',
    category: 'special',
    comingSoon: true,
    available_for: ['page'],
  },
  {
    type: 'hidden',
    label: 'Hidden Field',
    slug: 'hidden',
    category: 'special',
    available_for: ['page'],
  },
  {
    type: 'product-advise',
    label: 'Product Advise',
    slug: 'product_advise',
    category: 'special',
    available_for: ['page', 'ending'],
    defaultProps: {
      feedId: null,
      matchRules: [],
    },
  },

  // Contact Information
  { type: 'name', label: 'Name', slug: 'name', category: 'contact', available_for: ['page'] },
  { type: 'phone', label: 'Phone', slug: 'phone', category: 'contact', available_for: ['page'] },
  { type: 'email', label: 'Email', slug: 'email', category: 'contact', available_for: ['page'] },
  {
    type: 'address',
    label: 'Address',
    slug: 'address',
    category: 'contact',
    available_for: ['page'],
  },
  {
    type: 'kvk',
    label: 'KvK (Dutch Chamber of Commerce)',
    slug: 'kvk',
    category: 'contact',
    available_for: ['page'],
  },
  {
    type: 'company-name',
    label: 'Company Name',
    slug: 'company_name',
    category: 'contact',
    available_for: ['page'],
  },

  // Content Elements
  {
    type: 'heading',
    label: 'Heading',
    slug: 'heading',
    category: 'content',
    available_for: ['page', 'ending'],
  },
  {
    type: 'text',
    label: 'Text',
    slug: 'text',
    category: 'content',
    available_for: ['page', 'ending'],
  },
  {
    type: 'html',
    label: 'HTML',
    slug: 'html',
    category: 'content',
    available_for: ['page', 'ending'],
  },
  {
    type: 'notice',
    label: 'Notice',
    slug: 'notice',
    category: 'content',
    available_for: ['page', 'ending'],
    defaultProps: {
      content: '',
      variant: 'info',
    },
  },
  {
    type: 'image',
    label: 'Image',
    slug: 'image',
    category: 'content',
    available_for: ['page', 'ending'],
    defaultProps: {
      src: '',
      alt: '',
      alignment: 'center',
    },
  },
  {
    type: 'thank-you',
    label: 'Thank You',
    slug: 'thank_you',
    category: 'ending',
    available_for: ['ending'],
    defaultProps: {
      icon: 'check-circle',
      iconSize: '48',
      message: 'Thank you for your submission!',
    },
  },
  {
    type: 'submission-data',
    label: 'Submission Data',
    slug: 'submission_data',
    category: 'content',
    available_for: ['page', 'ending'],
    defaultProps: {
      title: 'Submission summary',
      showLabels: true,
      showEmptyFields: false,
      layout: 'vertical',
    },
  },
  {
    type: 'button',
    label: 'Button',
    slug: 'button',
    category: 'content',
    available_for: ['ending'],
    defaultProps: {
      label: 'Click me',
      url: 'https://example.com',
      openInNewTab: true,
      width: 'inline',
    },
  },
];
